'use strict';

jQuery(function($) {

	window.codecrewPackages = {
		init : function() {
			this.buyPackage();
			this.localizePrices();


		},

		buyPackage : function() {
			// $('.cc-package-product').find('.cc-variants').each(function() {
			// 	products.push({id: $(this).val()});
			// });

			// console.log('loaded')
			$('.js-buy-package').on('click', function() {
				var products = $(this).data('products');
				// console.log(products)
				addToCart(products, 0);
			});

			function addToCart(products, index) {
				if (index >= products.length) {
					window.location = '/cart';
					return;
				}

				$.post('/cart/add.js', { quantity: 1, id: products[index] }, function(response) {
					addToCart(products, index + 1);
				}, 'json').fail(function(error) {
					alert(error.responseJSON.description);
				});
			}

/*			var lo0 = window.location.hostname;
			var   lo1 = lo0.substring(0,2);
			var  prices = $('.js-buy-package .items .item .p_price span');
			var eu = $('.js-buy-package .items .item .p_price span.eu');
			var au = $('.js-buy-package .items .item .p_price span.au');

			if (lo1 =='eu' ) {
				prices.removeClass("display");
				eu.addClass("display")
			}else if (lo1 == 'au' ) {

			}else if (lo1 == 'ww' ){

				console.log(lo1);
			}*/
		},

		localizePrices : function() {
			var currencySymbols = {
				USD: '$',
				AUD: '$',
				EUR: '€'
			};

			$('[data-localize-price]').each(function() {
				var self = $(this);
				self.text(currencySymbols[Shopify.currency.active] + Math.ceil((self.data('localize-price') * Shopify.currency.rate)).toFixed(2));
			});
		}


	};

	codecrewPackages.init();
});
